import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { useExpanded, useFilters, useGlobalFilter, usePagination, useSortBy, useTable, } from "react-table";
import { Input, Row, Table } from "reactstrap";
import { DefaultColumnFilter } from "./filters";
import CustomPagination from "./CustomPagination";

const TableContainer = ({
    columns,
    data,
    tableClass,
    theadClass,
    thClass,
    divClass,
    divStyle,
    handlePageChange,
    currentPageSize,
    currentPage,
    rowCount,
    maxPage,
    showCheckbox=true,
    onRowClick,
    whiteRows=false,
}) => {
    useEffect(() => {
    }, [currentPageSize]);
    const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow, setPageSize, gotoPage } = useTable(
        {
            columns,
            data,
            defaultColumn: { Filter: DefaultColumnFilter },
            initialState: {
                pageIndex: 0, pageSize: currentPageSize
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
    );

    const generateSortingIndicator = (column) => {
        return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
    };

    useEffect(() => {
        setPageSize(currentPageSize);
    }, [currentPageSize, setPageSize]);

    useEffect(() => {
        if (typeof currentPage === 'number') {
            const zeroBased = Math.max(0, currentPage - 1);
            gotoPage(zeroBased);
        }
    }, [currentPage, gotoPage]);

    return (
        <Fragment>
            <div className={divClass} style={divStyle}>
                {/* <div className={divClass} style={{minHeight:"230px"}}> */}
                <Table hover {...getTableProps()} className={tableClass}>
                    <thead className={theadClass}>
                        {headerGroups.map((headerGroup, key) => (
                            <tr key={key} {...headerGroup.getHeaderGroupProps()}>
                                {showCheckbox &&
                                    <th scope="col" style={{ width: "50px" }}>
                                        <div className="form-check">
                                            <Input className="form-check-input" type="checkbox"
                                                onClick={(e) => {
                                                    const checkboxes = document.querySelectorAll(".rowCheckbox")
                                                    checkboxes.forEach((checkbox) => {
                                                        checkbox.checked = e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </th>
                                }
                                {headerGroup.headers.map((column) => (
                                    <th key={column.id} className={thClass} {...column.getSortByToggleProps()}>
                                        {column.render("Header")}
                                        {generateSortingIndicator(column)}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                            prepareRow(row)
                            return (
                                <Fragment key={row.id}>
                                    <tr
                                        {...row.getRowProps()}
                                        onClick={onRowClick ? () => onRowClick(row.original) : undefined}
                                        style={{
                                            ...(onRowClick ? { cursor: 'pointer' } : {}),
                                            ...(whiteRows ? { backgroundColor: '#ffffff' } : {}),
                                        }}
                                    >
                                        {showCheckbox && (
                                            <td>
                                                <Input className="form-check-input rowCheckbox" type="checkbox" value={row.original.id} />
                                            </td>
                                        )}
                                        {row.cells.map((cell) => {
                                            return (
                                                <td key={cell.column.id} {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </tbody>
                </Table>
            </div>


            <div className={"card-footer"}>
                <Row>
                    <CustomPagination rowCount={rowCount} currentPageSize={currentPageSize} currentPage={currentPage}
                        handlePageChange={handlePageChange} maxPage={maxPage} actualDataLength={data.length} />
                </Row>
            </div>
        </Fragment>
    );
};

TableContainer.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;